import React, { useMemo, useState } from "react";

const SearchSelect = ({
  data = [],
  value,
  onChange,
  onSearch,
  placeholder = "Search...",
  loading = false,
}) => {
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);

  const options = useMemo(() => {
    if (!search.trim()) return data;

    return data.filter((item) =>
      String(item.label || "")
        .toLowerCase()
        .includes(search.toLowerCase()),
    );
  }, [data, search]);

  const handleSearch = (e) => {
    const searchValue = e.target.value;

    setSearch(searchValue);
    setOpen(true);

    onSearch?.(searchValue);
  };

  const handleSelect = (option) => {
    // All select
    if (!option) {
      onChange?.("", {
        value: "",
        label: "All",
      });

      setSearch("");
      setOpen(false);

      // Search clear karne ke liye
      onSearch?.("");

      return;
    }

    // Normal option
    onChange?.(option.value, option);

    setSearch(option.label);
    setOpen(false);
  };

  return (
    <div className="relative w-full">
      <input
        type="text"
        value={search}
        placeholder={placeholder}
        onFocus={() => setOpen(true)}
        onChange={handleSearch}
        className="w-full rounded-md border border-gray-300 px-4 py-2
                   text-sm outline-none focus:border-blue-500
                   focus:ring-1 focus:ring-blue-500"
      />

      {open && (
        <div
          className="absolute z-50 mt-1 max-h-60 w-full overflow-auto
                     rounded-md border border-gray-200 bg-white shadow-lg"
        >
          {/* All */}
          <div
            onClick={() => handleSelect("")}
            className="cursor-pointer px-4 py-2 text-sm hover:bg-gray-100"
          >
            All
          </div>

          {loading ? (
            <div className="px-4 py-2 text-sm text-gray-500">Searching...</div>
          ) : options.length > 0 ? (
            options.map((item) => (
              <div
                key={item.value}
                onClick={() => handleSelect(item)}
                className="cursor-pointer px-4 py-2 text-sm hover:bg-gray-100"
              >
                {item.label}
              </div>
            ))
          ) : (
            <div className="px-4 py-2 text-sm text-gray-500">
              No results found
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchSelect;
